type LogoProps={variant?:'nav'|'footer'};
export function Logo({variant='nav'}:LogoProps){
 const footer=variant==='footer';
 return <a className={`brand brand-image ${footer?'brand-footer':'brand-nav'}`} href="/" aria-label="Xynysys Corporation home">
   <img src={footer?'/brand/xynysys-logo.png':'/brand/xynysys-navbar.png'} alt="Xynysys Corporation"/>
 </a>;
}
